// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"Breadcrumb-module--breadcrumb--3gnbS","breadcrumbIcon":"Breadcrumb-module--breadcrumb-icon--2LKkT","light":"Breadcrumb-module--light--2-ThS"};